// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tabsStyles } from "@rpsc/App/Widgets/XTabs/XTabs";
import { linkArrowStyle, mergeWithCss } from "@rpsc/XDL/Utilities";
import xScreen from "@rpsc/XDL/Utilities/xScreen";
import { css } from "styled-components";

tabsStyles.wrapper = {
    css: css`
        flex-wrap: wrap;
        width: 100%;
        ${({ isLoading }: any) => (isLoading ? "display: none;" : "")}
    `,
};

tabsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lte", "md")} {
            gap: 16px;
        }
    `,
};

tabsStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

tabsStyles.tabsContainer = {
    cssOverrides: {
        wrapper: css`
            padding: 0;
            gap: 16px;
        `,
    },
};

tabsStyles.link = {
    ...mergeWithCss(linkArrowStyle, {
        typographyProps: {
            size: 16,
            css: css`
                line-height: 22px;
            `,
        },
        css: css`
            ${xScreen("lte", "md")} {
                align-self: flex-start;
            }
        `,
    }),
};
